import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';

import { Product } from 'types/product';
import Location from 'services/Location';

import { LogoSize } from './LogoWithText';

export const logoContainer = css`
  display: flex;
  gap: var(${SpacingToken.Spacing3});
  align-items: center;
`;

export const logoText = css`
  font-family: Colfax, sans-serif;
  font-weight: 600;
  margin-top: 1px;
`;

export const logoStyles = (product: Product, size: LogoSize) => css`
  height: 32px;

  ${Location.getUrlParam('client_id') === import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID &&
  'height: 40px;'}

  width: auto;

  ${product &&
  size === LogoSize.SMALL &&
  Location.getUrlParam('client_id') !== import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID &&
  `
    max-height: 24px;
    width: auto;
  `}
`;
